import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Key Stats art: a fact sheet. A section caption, a hairline, then rows of a
 * label at left and a bolder value at right, the way the panel lists market
 * cap, float, shares out and the rest.
 */
const ROWS: [number, number, number][] = [
  [30, 34, 26],
  [43, 28, 30],
  [56, 40, 22],
  [69, 30, 34],
  [82, 36, 24],
]

export function KeyStatsArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <rect x={12} y={12} width={44} height={5} rx={2} fill="hsl(var(--primary) / 0.6)" />
      <path
        d="M12 22 H148"
        stroke="hsl(var(--muted-foreground) / 0.3)"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
      {ROWS.map(([y, labelWidth, valueWidth]) => (
        <g key={y}>
          <rect
            x={12}
            y={y + 1}
            width={labelWidth}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.14)"
          />
          <rect
            x={148 - valueWidth}
            y={y - 1}
            width={valueWidth}
            height={8}
            rx={2}
            fill="hsl(var(--foreground) / 0.32)"
          />
        </g>
      ))}
    </svg>
  )
}
